import Home from "../components/frontend/Home";
import About from "../components/frontend/About";
import Contact from "../components/frontend/Contact";
import ViewCategory from "../components/frontend/collections/ViewCategory";
import ViewProduct from "../components/frontend/collections/ViewProduct";
import { themedPage } from "../themes/templates";

import OrderSuccess from "../components/frontend/OrderSuccess";
import PaymentResult from "../components/frontend/PaymentResult";
import PolicyPage from "../components/frontend/PolicyPage";
import TrackOrder from "../components/frontend/TrackOrder";
import ForgetPassword from "../components/frontend/auth/ForgetPassword";
import Wishlist from "../components/frontend/Wishlist";
import SearchResults from "../components/frontend/SearchResults";
import AccountDashboard from "../components/frontend/account/AccountDashboard";
import OrderInvoice from "../components/frontend/OrderInvoice";

// ERROR PAGES
import Page403 from "../components/Errors/Page403";
import Page404 from "../components/Errors/Page404";

// AUTH / ADMIN LOGIN
import Login from "../components/frontend/auth/Login";
import Register from "../components/frontend/auth/Register";

// These pages use the template the published theme chose (see src/themes/templates).
const ProductDetails = themedPage("product");
const Cart = themedPage("cart");
const Checkout = themedPage("checkout");

const publicRouteList = [
  { path: "/", exact: true, name: "Home", component: Home },
  { path: "/about", exact: true, name: "About", component: About },
  { path: "/contact", exact: true, name: "Contact", component: Contact },

  { path: "/403", exact: true, name: "Page403", component: Page403 },
  { path: "/404", exact: true, name: "Page404", component: Page404 },

  { path: "/login", exact: true, name: "Login", component: Login },
  { path: "/admin/login", exact: true, name: "AdminLogin", component: Login },
  { path: "/register", exact: true, name: "Register", component: Register },

  {
    path: "/collection",
    exact: true,
    name: "Collections",
    component: ViewCategory,
  },
  {
    path: "/collection/:slug",
    exact: true,
    name: "ViewProduct",
    component: ViewProduct,
  },
  {
    path: "/collection/:categorySlug/:productSlug",
    exact: true,
    name: "ProductDetails",
    component: ProductDetails,
  },
  { path: "/cart", exact: true, name: "Cart", component: Cart },
  { path: "/checkout", exact: true, name: "Checkout", component: Checkout },
  { path: "/order-success/:orderId", exact: true, name: "OrderSuccess", component: OrderSuccess },
  { path: "/order-success", exact: true, name: "OrderSuccessFallback", component: OrderSuccess },
  { path: "/payment/:orderId", exact: true, name: "PaymentResult", component: PaymentResult },
  { path: "/policies/:type", exact: true, name: "Policy", component: PolicyPage },
  { path: "/order-invoice/:orderId", exact: true, name: "OrderInvoice", component: OrderInvoice },
  { path: "/invoice/:orderId", exact: true, name: "OrderInvoiceShort", component: OrderInvoice },
  { path: "/track-order", exact: true, name: "TrackOrder", component: TrackOrder },
  { path: "/wishlist", exact: true, name: "Wishlist", component: Wishlist },
  { path: "/search", exact: true, name: "SearchResults", component: SearchResults },
  { path: "/account", exact: true, name: "AccountDashboard", component: AccountDashboard },
  {
    path: "/resetpassword/:token",
    exact: true,
    name: "ForgetPassword",
    component: ForgetPassword,
  },
];

export default publicRouteList;
